export default __webpack_public_path__ + "static/media/domestic-prohibited.43fca406.png";